import RecoverStep from "./recover_step";
import {attachSelectableHandler, showVmsList} from "../utils/recover_utils";

const TEMPLATE = 'virtualization-browse';

export default class ShowVmExist extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.render = {
            searchComplete: true,
            devicePage: true
        };
        fr.render('showVMExist');
    }

    transitionViewService(data, el, fr) {
        attachSelectableHandler(el,(d) => {
            showVmsList(data);
        });
    }

}
